import { NavLink, useLocation } from 'react-router-dom';
import { FiHome, FiGrid, FiGift, FiShoppingBag, FiUser } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

// Pages with their own sticky action bar at the bottom
const HIDDEN_ON = [/^\/products\/[^/]+$/, /^\/checkout/, /^\/cart$/];

const itemCls = ({ isActive }) =>
  `flex flex-col items-center justify-center gap-0.5 flex-1 h-full font-sans text-[10px] font-semibold transition-colors ${
    isActive ? 'text-terra-500' : 'text-wood-400'
  }`;

/** App-style tab bar for phones (hidden from md up). */
const MobileBottomNav = ({ onCartOpen }) => {
  const { pathname } = useLocation();
  const { getCartCount } = useCart();
  const { isAuthenticated } = useAuth();
  const cartCount = getCartCount();

  if (HIDDEN_ON.some(re => re.test(pathname))) return null;

  return (
    <>
      {/* Spacer so page content isn't hidden behind the bar */}
      <div className="h-16 md:hidden" aria-hidden="true" />
      <nav
        aria-label="Quick navigation"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-skin-100 shadow-[0_-2px_12px_rgba(47,30,20,0.06)]"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <div className="flex items-stretch h-14">
          <NavLink to="/" end className={itemCls}>
            <FiHome className="text-lg" /> Home
          </NavLink>
          <NavLink to="/products" end className={itemCls}>
            <FiGrid className="text-lg" /> Shop
          </NavLink>
          <NavLink to="/gift-guide" className={itemCls}>
            <FiGift className="text-lg" /> Gifts
          </NavLink>
          <button type="button" onClick={onCartOpen} className={itemCls({ isActive: false })} aria-label={`Cart, ${cartCount} items`}>
            <span className="relative">
              <FiShoppingBag className="text-lg" />
              {cartCount > 0 && (
                <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-terra-500 text-white text-[9px] font-bold leading-4 text-center">
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </span>
            Cart
          </button>
          <NavLink to={isAuthenticated ? '/profile' : '/login'} className={itemCls}>
            <FiUser className="text-lg" /> {isAuthenticated ? 'Account' : 'Sign in'}
          </NavLink>
        </div>
      </nav>
    </>
  );
};

export default MobileBottomNav;
